import { FC } from 'react';
import { Page } from '../../../components';
import { JobBulkEditDetails } from './JobBulkEditDetails';

export const JobBulkEditPage: FC = () => {
  return (
    <Page title="Bulk Edit Jobs">
      <JobBulkEditDetails />
    </Page>
  );
};
